import React from "react";
import { CalendarDays, AlertTriangle } from "lucide-react";
import { format } from "date-fns";

const InfoAviso = ({ aviso }) => {
  const { descripcion, fecha, tipo } = aviso;
  const formattedDate = format(new Date(fecha), "dd/MM/yyyy HH:mm");
  const tipoColor = tipo === "Tardanza" ? "text-red-600" : "text-yellow-400";

  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-4">
      <div className="bg-[#1a1a1a] border-2 border-red-700 rounded-2xl shadow-lg max-w-xl w-full animate-pulse-slow p-6 text-white">
        
        <p className="text-lg text-center italic">"{descripcion}"</p>

        <div className="flex justify-around items-center text-sm mt-6">
          <div className="flex items-center gap-2">
            <CalendarDays size={18} className="text-gray-300" />
            <span className="text-gray-300">{formattedDate}</span>
          </div>
          <div className="flex items-center gap-2">
            <AlertTriangle size={18} className={tipoColor} />
            <span className={`uppercase font-bold ${tipoColor}`}>
              {tipo}
            </span>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-slow {
          0%, 100% { box-shadow: 0 0 10px red; }
          50% { box-shadow: 0 0 25px red; }
        }

        .animate-pulse-slow {
          animation: pulse-slow 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default InfoAviso;
